import { GetMedicalEquipmentApiParameter } from "@GeriMed/Services/MedicalEquipmentService";
import ApplicationStateGeriMed from "@GeriMed/Store/GeriMedState";
import { getDataView } from "@insite/client-framework/Store/Data/DataState";
import { createContext } from "react";

export function getMedicalEquipmentDataView(state: ApplicationStateGeriMed, parameter: GetMedicalEquipmentApiParameter) {
    const data = getDataView(state.dataMedicalEquipment,parameter);
    return data;
}

export const MedicalEquipmentDataViewContext = createContext<ReturnType<typeof getMedicalEquipmentDataView>>({
    value: undefined,
    isLoading: false,
});
